import { createBrowserRouter, Navigate } from 'react-router';
import RouteErrorBoundary from '@/components/RouteErrorBoundary';
import AuthenticatedLayout from '@/layouts/AuthenticatedLayout';
import RootLayout from '@/layouts/RootLayout';

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    errorElement: <RouteErrorBoundary />,
    children: [
      {
        path: '/',
        element: <AuthenticatedLayout />,
        children: [
          { index: true, element: <Navigate to="/cpo-analytics" replace /> },
          {
            path: 'cpo-analytics',
            children: [
              {
                index: true,
                lazy: async () => {
                  const { CpoAnalyticsDashboardScreen } = await import('@/modules/cpo-analytics');
                  return { Component: CpoAnalyticsDashboardScreen };
                },
              },
              {
                // Static segment, declared before the param so "combined" is
                // never read as a station id.
                path: 'combined',
                lazy: async () => {
                  const { CpoCombinedDetailScreen } = await import('@/modules/cpo-analytics');
                  return { Component: CpoCombinedDetailScreen };
                },
              },
              {
                path: ':stationId',
                lazy: async () => {
                  const { CpoStationDetailScreen } = await import('@/modules/cpo-analytics');
                  return { Component: CpoStationDetailScreen };
                },
              },
            ],
          },
          {
            path: 'qr-payment',
            lazy: async () => {
              const { QrPaymentScreen } = await import('@/modules/qr-payment');
              return { Component: QrPaymentScreen };
            },
          },
          {
            path: 'oda',
            children: [
              {
                index: true,
                lazy: async () => {
                  const { OdaDashboardScreen } = await import('@/modules/oda');
                  return { Component: OdaDashboardScreen };
                },
              },
              {
                path: ':eanId',
                lazy: async () => {
                  const { OdaDetailScreen } = await import('@/modules/oda');
                  return { Component: OdaDetailScreen };
                },
              },
            ],
          },
          {
            path: 'alerts',
            lazy: async () => {
              const { AlertsScreen } = await import('@/modules/alerts');
              return { Component: AlertsScreen };
            },
          },
          {
            path: 'helpdesk',
            lazy: async () => {
              const { HelpdeskScreen } = await import('@/modules/helpdesk');
              return { Component: HelpdeskScreen };
            },
          },
          {
            path: 'billing',
            children: [
              {
                path: 'split-billing',
                lazy: async () => {
                  const { SplitBillingScreen } = await import('@/modules/billing');
                  return { Component: SplitBillingScreen };
                },
              },
              {
                path: 'invoices',
                lazy: async () => {
                  const { InvoicesScreen } = await import('@/modules/billing');
                  return { Component: InvoicesScreen };
                },
              },
              {
                path: 'checklist',
                lazy: async () => {
                  const { ChecklistScreen } = await import('@/modules/checklist');
                  return { Component: ChecklistScreen };
                },
              },
              {
                path: 'fees',
                lazy: async () => {
                  const { FeesScreen } = await import('@/modules/billing');
                  return { Component: FeesScreen };
                },
              },
            ],
          },
          {
            path: '*',
            lazy: async () => {
              const NotFound = (await import('@/pages/NotFound')).default;
              return { Component: NotFound };
            },
          },
        ],
      },
    ],
  },
]);
